<template>
  <a-spin :spinning="loading">
    <a-card :bordered="false">
      <div>
        <a-form :form="form" >
          <a-row>
            <a-col :span="24">
              <a-divider orientation="left">
                合同信息
              </a-divider>
            </a-col>
            <a-col :span="12">
              <a-form-item label="系统编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-decorator="['number']" disabled/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="报告类型" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select
                  option-label-prop="tt"
                  :show-arrow="false"
                  :filter-option="false"
                  :not-found-content="null"
                  show-search
                  allow-clear
                  v-decorator="[
                    'report_type',
                    {
                      rules: [
                        { required: true, message: '' },
                      ],
                    },
                  ]"
                  placeholder="请选择"
                  :default-active-first-option="false"
                >
                  <a-select-option v-for="(item, index) in reportTypeList" :key="index" :tt="item">
                    {{ item }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12" v-if="data">
              <a-form-item label="采销全流程" :label-col="labelCol" :wrapper-col="wrapperCol">
                {{ this.data['project'] }}
              </a-form-item>
            </a-col>
            <a-col :span="12" v-if="data">
              <a-form-item label="货物名称" :label-col="labelCol" :wrapper-col="wrapperCol">
                {{ this.data['category'] }}
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-divider orientation="left">
                报告数据信息
              </a-divider>
            </a-col>
            <a-col :offset="2" :span="18">
              <a-form-item label="" >
                <a-button icon="plus" @click="handleAddReportData">新建</a-button>
                <a-table
                  bordered
                  :data-source="json_data"
                  :columns="reportDataColumns"
                  v-if="this.json_data.length > 0"
                  :pagination="false"
                  key="key">
                  <template slot="action" slot-scope="text, record">
                    <a-popconfirm
                      v-if="json_data.length"
                      title="确定删除?"
                      @confirm="() => onReportDataDelete(record.key)"
                    >
                      <a href="javascript:;">删除</a>
                    </a-popconfirm>
                  </template>
                </a-table>
              </a-form-item>
            </a-col>
          </a-row>
          <a-form-item v-bind="buttonCol">
            <a-row>
              <a-col offset="8" span="6">
                <a-button type="primary" html-type="submit" @click="handleSubmit">提交</a-button>
              </a-col>
              <a-col span="10">
                <a-button @click="handleGoBack">返回</a-button>
              </a-col>
            </a-row>
          </a-form-item>
        </a-form>
        <report-data-form
          ref="reportDataCreateForm"
          @cancel="handleAddReportDataCancel"
          @ok="handleReportDataOk"
          :record="undefined"
          :visible="reportDataVisibleForm"
          v-if="reportDataVisibleForm"
          :loading="false"
          :model="undefined" />
      </div>
    </a-card>
  </a-spin>
</template>

<script>
import moment from 'moment'
import pick from 'lodash.pick'
import ReportDataForm from '../modules/ReportDataForm'
import {
  goods_report_list,
  goods_report_update
} from '@/api/trade_report'
export default {
  name: 'TableEdit',
  components: {
    ReportDataForm
  },
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        labelCol: {
          xs: { span: 3 },
          sm: { span: 3 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      },
      form: this.$form.createForm(this),
      id: 0,
      sell_contract_id: 0,
      type: '12',
      data: {},
      loading: false,
      clientFetching: false,
      clientList: [],
      json_data: [],
      reportDataVisibleForm: false,
      guarantee_period_start_date: undefined,
      guarantee_period_end_date: undefined,
      fields: ['number', 'report_type'],
      reportTypeList: this.$Dictionaries.trade_goods_report_types,
      reportDataColumns: [
        {
          title: '名称',
          width: 100,
          dataIndex: 'name'
        },
        {
          title: '内容',
          width: 200,
          dataIndex: 'content'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 50,
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  mounted () {
    this.loadContract()
  },
  methods: {
    moment,
    handleGoBack () {
      // this.$emit('onGoBack')
      this.$router.go(-1)
    },
    handleAddReportData () {
      this.reportDataVisibleForm = true
    },
    onReportDataDelete (key) {
      const dataSource = [...this.json_data]
      this.json_data = dataSource.filter(item => item.key !== key)
    },
    handleAddReportDataCancel () {
      this.reportDataVisibleForm = false
      const form = this.$refs.reportDataCreateForm.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleReportDataOk (date) {
      const form = this.$refs.reportDataCreateForm.form
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values, date)
          // 新增
          const current_date = new Date()
          values.key = current_date.getHours() + '' + current_date.getMinutes() + '' + current_date.getSeconds()
          this.json_data.push(values)
          this.reportDataVisibleForm = false
          form.resetFields()
        }
      })
    },
    loadContract () {
      this.loading = false
      goods_report_list({ id: this.$route.params.id }).then(res => {
        const list = res.data.entries
        if (list && list.length > 0) {
          this.data = list[0]
          this.id = this.data.id
          this.json_data = Object.entries(this.data['report_data']).map(([name, content]) => ({
            name,
            content,
            key: Math.random() * 100000
          }))
          this.loadEditInfo(this.data)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleSubmit () {
      const { form: { validateFields } } = this
      validateFields((err, values) => {
        if (!err) {
          this.loading = true
          values['report_data'] = this.json_data.map(item => {
            item.key = undefined
            return item
          }).reduce((acc, item) => {
            acc[item['name']] = item['content']
            return acc
          }, {})
          goods_report_update(values, this.id).then((res) => {
            if (res.code === 1000) {
              this.handleGoBack()
              console.log(res, '修改成功')
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    loadEditInfo (data) {
      const { form } = this
      console.log(`将加载 ${this} 信息到表单`)
      data.report_type = '' + data.report_type
      const formData = pick(data, this.fields)
      form.setFieldsValue(formData)
    }
  }
}
</script>
